module.exports = __webpack_public_path__ + "img/maintenance.68068f99.svg";